import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { FaRegCalendarCheck } from "react-icons/fa6";
import { validateDayjsRange } from "../../Helpers/Utils/dateRange";

interface ITopupDateRangePickerProps {
  // dateRange?: [Dayjs | null, Dayjs | null];
  handleFilterChange: (key: any, value: any) => void;
  height?: number;
  value?: [Dayjs | null, Dayjs | null];
  /** Notifies the parent whether the current range is valid, so it can gate "Apply". */
  onValidityChange?: (valid: boolean) => void;
}

const ITopupDateRangePicker: React.FC<ITopupDateRangePickerProps> = ({
  handleFilterChange,
  height = 38,
  value,
  onValidityChange,
}) => {
  const [rangeError, setRangeError] = useState<string | undefined>(undefined);

  // Validate (no future dates, From <= To), notify parent, then propagate the change.
  const handleRangeChange = (newValue: [Dayjs | null, Dayjs | null]) => {
    const { valid, message } = validateDayjsRange(newValue);
    setRangeError(valid ? undefined : message);
    onValidityChange?.(valid);
    handleFilterChange("dateRange", newValue);
  };
  const [isOpenCalender, setIsOpenCalender] = React.useState(false);
  const today = dayjs();
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([
    today,
    today,
  ]);

  useEffect(() => {
    const observer = new MutationObserver(removeLicenseMessage);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [isOpenCalender]);

  const removeLicenseMessage = () => {
    const root = document.querySelector(".MuiDateRangeCalendar-root");
    const firstDiv = root?.querySelector("div");
    if (firstDiv && firstDiv.textContent?.includes("Missing license key")) {
      firstDiv.remove();
    }
    setTimeout(() => {
      const root = document.querySelector(".MuiDateRangeCalendar-root");
      const firstDiv = root?.querySelector("div");

      if (firstDiv && firstDiv.textContent?.includes("Missing license key")) {
        firstDiv.remove();
      }
    }, 1000);
  };

  const handleOpen = () => {
    setIsOpenCalender(true);
  };

  const handleClose = () => {
    setIsOpenCalender(false);
  };
  return (
    <div
  style={{
    minWidth: "100%",
    display: "flex",
    flexDirection: "column",
  }}
>
  <div style={{ minWidth: "100%", height: `${height}px` }}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        slots={{ field: SingleInputDateRangeField }}
        value={value || [today, today]}
        onOpen={handleOpen}
        onClose={handleClose}
        format="DD.MM.YYYY"
        disableFuture
        onChange={(newValue) =>
          handleRangeChange(newValue as [Dayjs | null, Dayjs | null])
        }
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            placeholder: "Select date range",
            sx: {
              "& .MuiInputBase-root": {
                height: `${height - 3}px`,
              },
              backgroundColor: "#fff",
              borderRadius: 2,
            },
          },
          popper: {
            disablePortal: true,
            sx: {
              zIndex: 2000,
              position: "absolute !important",
            },
          },
        }}
      />
    </LocalizationProvider>
  </div>

  {rangeError ? (
    <div style={{ color: "#d32f2f", fontSize: 12, marginTop: 4 }}>
      {rangeError}
    </div>
  ) : null}

  {/* <div
    style={{
      position: "absolute",
      right: "10px",
      marginTop: "3px",
      zIndex: 0,
    }}
  >
    <FaRegCalendarCheck />
  </div> */}
</div>

    // <div
    //   style={{
    //     minWidth: "100%",
    //     position: "relative",
    //     height: `${height}px`,
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "flex-end",
    //   }}
    // >
    //   <div style={{ minWidth: "100%", height: `${height}px`, zIndex: 9999 }}>
    //     <LocalizationProvider dateAdapter={AdapterDayjs}>
    //       <DateRangePicker
    //         slots={{ field: SingleInputDateRangeField }}
    //         value={value || [today,today]}
    //         onOpen={handleOpen}
    //         onClose={handleClose}
    //         format="DD.MM.YYYY"
            
    //         onChange={(newValue) => handleFilterChange("dateRange", newValue)}
    //         slotProps={{
    //           textField: {
    //             size: "small",
    //             fullWidth: true,
    //             placeholder: "Select date range",
    //             sx: {
    //               "& .MuiInputBase-root": {
    //                 height: `${height - 3}px`,
    //               },
    //               backgroundColor: "#fff",
    //               borderRadius: 2,
    //             },
    //           },
 
    //         }}
    //       />
    //     </LocalizationProvider>
    //   </div>
    //   <div
    //     style={{
    //       position: "absolute",
    //       right: "10px",
    //       marginTop: "3px",
    //       zIndex: 0,
    //     }}
    //   >
    //     <FaRegCalendarCheck />
    //   </div>
    // </div>
  );
};

export default ITopupDateRangePicker;
